import React, { useState } from 'react';
import {
  ButtonBase,
  IconTags16,
  Inline,
  Link,
  RichText,
  Text,
} from '@stitch-fix/mode-react';
import { TermsAndCondModal } from './TermsAndCondModal';
import type { PromoDiscountOffer } from '../../../../types/definitions/vendor/graphql-schema.d';

const PromoDiscountOfferLabel = ({ offer }: { offer: PromoDiscountOffer }) => {
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);

  return (
    <>
      <Inline
        mb={{ sm: 0.5, md: 0.75 }}
        mt={0.5}
        spacing={0.25}
        color="blue-45"
        vAlign="center"
      >
        <IconTags16 />
        <Text setting="body-small">
          <strong>
            <RichText>{String(offer.displayLabel.formatted)}</RichText>
          </strong>
        </Text>
        <Link as={ButtonBase} onClick={() => setShowTermsAndConditions(true)}>
          <Text setting="body-small">
            <strong>
              <RichText>{String(offer.termsAndConditions.label)}</RichText>
            </strong>
          </Text>
        </Link>
      </Inline>
      {showTermsAndConditions && (
        <TermsAndCondModal
          closeModal={() => setShowTermsAndConditions(false)}
          termsAndConditions={offer.termsAndConditions.content}
        />
      )}
    </>
  );
};

export default PromoDiscountOfferLabel;
